import { render, staticRenderFns } from "./CreditsHistoryRow.vue?vue&type=template&id=058e97c8&scoped=true&"
import script from "./CreditsHistoryRow.vue?vue&type=script&lang=ts&"
export * from "./CreditsHistoryRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058e97c8",
  null
  
)

export default component.exports